import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { BankVerificationModelPageRoutingModule } from './bank-verification-model-routing.module';

import { BankVerificationModelPage } from './bank-verification-model.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    BankVerificationModelPageRoutingModule
  ],
  declarations: [BankVerificationModelPage]
})
export class BankVerificationModelPageModule {}
